import { useContext } from 'react'

import { TaggingTableSelectionContext } from './TaggingContexts'

export const useTaggingTableSelection = () => {
  const context = useContext(TaggingTableSelectionContext)

  if (!context) {
    throw new Error(
      'useTaggingTableSelection must be used within a TaggingProvider',
    )
  }

  return context
}

export const useOptionalTaggingTableSelection = () =>
  useContext(TaggingTableSelectionContext)
